<template>
    <!--  VISTA LISTAR-->
    <template v-if="view === 'listar'">
        <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
            @updateValues="setupUpdateValues"></HeaderComponent>
        <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns"
            :queries="queries" @updateValues="setupUpdateValues"></FilterRefactComponent>
        <TableComponent :entity="entity" :selected-data="selectedTipoDocumento" :table-columns="tableColumns"
            :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
            @updateValues="setupUpdateValues"></TableComponent>
        <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
            :optionalParams="queries" @updateValues="setupUpdateValues"></PaginateRefactComponent>
    </template>
    <!--    VISTA CREAR - ACTUALIZAR-->
    <template v-else>
        <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedTipoDocumento"
            :load-data="loadDataTipoDocumento" :entity="entity" :auth-token="authToken" :list-api="listApi"
            :queries="queries" @updateValues="setupUpdateValues">
            <component :is="childFormComponent" :load-data="loadDataTipoDocumento" @updateValues="setupUpdateValues">
            </component>
        </CreateUpdateComponent>
    </template>
</template>
<script>
import { reactive, ref } from "vue";
import { useAuth } from "@/components/auth/store/composables";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import TipoDocumentoCrearActualizarComponent from "@/components/parametros/components/TipoDocumentoCrearActualizarComponent";
import { useLayoutMain } from "@/layouts/main";

export default {
    name: 'TipoDocumento',
    components: {
        HeaderComponent,
        FilterRefactComponent,
        TableComponent,
        PaginateRefactComponent,
        CreateUpdateComponent,
        TipoDocumentoCrearActualizarComponent
    },
    data: function () {
        return {
            Object: Object,
            title: 'Tipo Documento',
            entity: { gender: 'm', value: 'tipo de documento' },
            childFormComponent: 'TipoDocumentoCrearActualizarComponent',
            tableColumns: {
                'id': {
                    isFilter: false,
                    isOrder: false,
                    isVisibleInTable: true,
                    value: 'ID'
                },
                'nombre_tipo_identificacion': {
                    isFilter: true,
                    isOrder: true,
                    isVisibleInTable: true,
                    value: 'Tipo de Documento'
                },
                'estado': {
                    isFilter: true,
                    isOrder: true,
                    isVisibleInTable: false,
                    value: 'Estado'
                },
                'created_at': {
                    isFilter: true,
                    isOrder: true,
                    isVisibleInTable: false,
                    value: 'Fecha de creación'
                }
            }
        }
    },
    async setup() {
        const authStored = useAuth();
        const view = ref('listar');
        const collectionData = ref([]);
        const authToken = ref(authStored.authToken);
        const selectedTipoDocumento = ref({
            id: '',
            nombre_tipo_identificacion: '',
            estado: ''
        });
        const loadDataTipoDocumento = ref({
            nombre_tipo_identificacion: ''
        });
        const listApi = reactive({
            create: process.env.VUE_APP_NEST_TIPODOCUMENTO_CREATE,
            list: process.env.VUE_APP_NEST_TIPODOCUMENTO_FINDALL,
            update: process.env.VUE_APP_NEST_TIPODOCUMENTO_UPDATE,
            updateState: process.env.VUE_APP_NEST_TIPODOCUMENTO_UPDATESTATE
        });
        const {
            paginate,
            queries,
            setupUpdateValues,
            cleanLoadSelectedData
        } = await useLayoutMain(view, collectionData, authToken, selectedTipoDocumento, loadDataTipoDocumento, listApi);
        return {
            view,
            collectionData,
            authToken,
            selectedTipoDocumento,
            loadDataTipoDocumento,
            listApi,
            paginate,
            queries,
            setupUpdateValues,
            cleanLoadSelectedData
        };
    }
}
</script>